import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import './UserRoleModal.scss'

import Modal from '../Modal'
import Description from './components/Description/Description'
import Groups from './components/Groups/Groups'
import Roles from './components/Roles/Roles'

import i18n from '../../../i18n'
import { API__COMMON } from '../../../api'
import Toast from '../../Toast/Toast'
import { EDUCATION_GROUP_ID } from '../../../common/constants/ProductConstants'
import AnalyticsMonitor from '../../../common/services/AnalyticsMonitor'

const STEPS_ENUM = {
    SELECT_GROUP: 1,
    SELECT_ROLE: 2,
}

const TITLES = {
    [STEPS_ENUM.SELECT_GROUP]: i18n.t('Choose your sector'),
    [STEPS_ENUM.SELECT_ROLE]: i18n.t('Choose your profile'),
}
const SUB_TITLES = {
    [STEPS_ENUM.SELECT_GROUP]: i18n.t('Choose the option that best represents you'),
    [STEPS_ENUM.SELECT_ROLE]: i18n.t('Choose the role that suits\nyou best'),
}

const UserRoleModal = ({ isEditMode = true, onSelect = () => {}, onClose }) => {
    const [isLoading, setIsLoading] = useState(false)
    const [step, setStep] = useState(STEPS_ENUM.SELECT_GROUP)
    const [list, setList] = useState([])
    const [selectedGroup, setSelectedGroup] = useState(null)

    useEffect(() => {
        async function fetchList() {
            setIsLoading(true)
            try {
                const usersRoles = await API__COMMON.GET_USERS_PROJECTS_ROLES()
                setList(usersRoles)
            } catch (err) {
                console.error(err)
                Toast('error', {})
            } finally {
                setIsLoading(false)
            }
        }

        fetchList()
    }, [])

    const getActionButtonText = (isEditMode, group) => {
        if (isEditMode) {
            return i18n.t('Accept!')
        }
        if (group.customId === EDUCATION_GROUP_ID) {
            return i18n.t('Let’s start!')
        }
        return i18n.t('Start my free trial')
    }

    return (
        <Modal closeOnEsc={isEditMode} closeOnOverlayClick={isEditMode} onClose={() => onClose()}>
            <div className="user-role-modal">
                {isEditMode && <div className="close-btn" onClick={() => onClose()} />}
                <Description title={TITLES[step]} subTitle={SUB_TITLES[step]} />
                {step === STEPS_ENUM.SELECT_GROUP && (
                    <Groups
                        list={list}
                        isLoading={isLoading}
                        onSelect={group => {
                            setSelectedGroup(group)
                            setStep(STEPS_ENUM.SELECT_ROLE)
                            AnalyticsMonitor.track('User group chosen', { groupId: group.customId })
                        }}
                    />
                )}
                {step === STEPS_ENUM.SELECT_ROLE && (
                    <Roles
                        backButtonText={i18n.t('Back')}
                        actionButtonText={getActionButtonText(isEditMode, selectedGroup)}
                        onBack={() => {
                            setSelectedGroup(null)
                            setStep(STEPS_ENUM.SELECT_GROUP)
                        }}
                        selectedGroup={selectedGroup}
                        onSelect={async data => await onSelect(data)}
                        onClose={() => onClose()}
                    />
                )}
            </div>
        </Modal>
    )
}

export default UserRoleModal
